import React, { useState } from "react";
import "./Resources.css";
import { Button } from "react-bootstrap";
import Layout from "../../HOC/Layput/Layout";
const Resources = () => {
  document.title = "VK Global Publications | Resources";
  const [resources, setresources] = useState([
    {
    date: "06 oct, 2020",
    name: "Analysis of Financial Statements (Solutions), Class - XII for CBSE",
    link: "http://vkpublications.com/pdf/Analysis%20of%20Financial%20Statements%20(Solutions),%20Class%20-%20XII%20for%20CBSE.pdf",
  },
  {
    date: "06 oct, 2020",
    name: "Accounting for Not-for-Profit Organisations, Partnership Firms and Companies (Solutions), Class - XII for CBSE",
    link: "http://vkpublications.com/pdf/Accounting%20for%20Not-for-Profit%20Organisations,%20Partnership%20Firms%20and%20Companies%20(Solutions),%20Class%20-%20XII%20for%20CBSE.pdf",
  },
    {
      date: "03 oct, 2020",
      name: "Management Accounting (Solutions), BCom-III and BBA-II for HPU",
      link: "http://vkpublications.com/pdf/Management%20Accounting%20(Solutions),%20BCom-III%20and%20BBA-II%20for%20HPU.pdf",
    },
    {
      date: "03 oct, 2020",
      name: "Financial Management (Solutions), B.Com-III for Punjab University",
      link: "http://vkpublications.com/pdf/Financial%20Management%20(Solutions)-B.Com-III%20for%20Punjab%20University.pdf",
    },
    {
      date: "03 oct, 2020",
      name: "Cost Accounting (Solutions), B.Com-II For Punjab University",
      link: "http://vkpublications.com/pdf/Cost%20Accounting%20(Solutions)-B.Com-II%20For%20Punjab%20University.pdf",
    },
    {
      date: "03 oct, 2020",
      name: "Analysis of Financial Statements (Solutions), Class - XII for CBSE",
      link: "http://vkpublications.com/pdf/Analysis%20of%20Financial%20Statements%20(Solutions),%20Class%20-%20XII%20for%20CBSE.pdf",
    },
    {
      date: "28 Sep, 2020",
      name: "Cost Accounting (Solutions) - B.Com-II for  HPU",
      link:
        "http://vkpublications.com/pdf/cost_accounting_solutions_B.Com-II_for_HPU.pdf",
    },
    {
      date: " 20 Sep, 2020",
      name: " Income Tax (Problems and Solutions)- B.Com for KUK, MDU, CDLU",
      link: "http://vkpublications.com/pdf/Income_Tax_Solutions.pdf",
    },
    {
      date: " 24 June, 2020",
      name: "Addendum - 10th Mathematics CBSE Examination Paper",
      link:
        "http://vkpublications.com/pdf/10th_mathematics%20_xamidea_QR_%20code_papers.pdf",
    },
    {
      date: " 24 June, 2020",
      name: "Addendum - 10th Science CBSE Examination Paper",
      link:
        "http://vkpublications.com/pdf/10th_science_%20xamidea_QR_code_papers.pdf",
    },
    {
      date: " 24 June, 2020",
      name: "Addendum - 10th Social Science CBSE Examination Paper",
      link:
        "http://vkpublications.com/pdf/10th_social_%20science_xamidea_QR_code_papers.pdf",
    },
    {
      date: " 24 June, 2020",
      name: "Addendum - 10th English CBSE Examination Paper",
      link:
        "http://vkpublications.com/pdf/10th_english_%20xamidea_QR_code_papers.pdf",
    },
   
  ]);
  return (
    <div>
      <div className="row">
        <div className="col-md-12 offset-xs-1">
          <ul className="timeline">
            {resources.map((item, index) => {
              return (
                <li key = {index}>
                  <a href="" className="float-right date">
                    {item.date}
                  </a>
                  <p>
                    <h5 className = "resource__name">{item.name}</h5>
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button className="downloadBtn">Download Pdf</Button>
                    </a>
                  </p>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Layout(Resources, "Resources");
